import { Component, OnInit } from '@angular/core';
import { MenuService } from 'app/services/menu.service'
import { CookieService } from 'ngx-cookie-service'

@Component({
  selector: 'app-onboardings',
  templateUrl: './onboardings.component.html',
  styleUrls: ['./onboardings.component.scss']
})
export class OnboardingsComponent implements OnInit {

  url

  constructor(private menuService: MenuService,
    private cookies: CookieService) {}

  ngOnInit() {
    this.url = this.menuService.getScreen('ONBGS', true).url + this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }

}
